import type { ComputedRef } from 'vue'
import type { Team } from '../interfaces'

import { useTeamsStore } from './store'
import { useTeamDelete } from '../../api/teams/delete.hook'
import { useTeamsApi } from '../../api/teams/list.hook'

interface DeleteTeamReturn {
  teamToDelete: ComputedRef<Team | null>
  isOpen: ComputedRef<boolean>
  isDeleting: ComputedRef<boolean>
  confirm: () => Promise<void>
  cancel: () => void
}

/** List-side delete: confirm the row targeted in the store, then refetch the current page. */
export const useDeleteTeam = (): DeleteTeamReturn => {
  const store = useTeamsStore()

  const teamToDelete = computed<Team | null>(() => store.getTeamToDelete)
  const isOpen = computed<boolean>(() => store.isModalDelete)
  const isDeleting = computed<boolean>(() => store.isSaving)

  const cancel = (): void => {
    store.setTeamToDelete(null)
  }

  const confirm = async (): Promise<void> => {
    const team = store.getTeamToDelete

    if (!team) return

    const ok = await useTeamDelete(team.id)

    if (ok) {
      store.setTeamToDelete(null)
      await useTeamsApi()
    }
  }

  return { teamToDelete, isOpen, isDeleting, confirm, cancel }
}
